import React from "react";
import PropTypes from "prop-types";
import ReactTable from "react-table";
import { useHistory } from "react-router-dom";
import { IoBusiness } from "react-icons/io5";
import { Tooltip as ReactTooltip } from "react-tooltip";

import ReportsList from "./ReportsList";
import HeaderWrapper from "../common/HeaderWrapper";

import "./ReportsPage.scss";

const reports = [
  {
    name: "Active Contracts",
    type: "Management",
    url: "/app/reports/active-contracts",
    target: "_self",
    description: ""
  },
  {
    name: "Active Projects",
    type: "Management",
    url: "/app/reports/active-projects",
    target: "_self",
    description: ""
  },
  {
    name: "Billable Customer Rates",
    type: "Management",
    url: "/app/reports/billable-customer-rates",
    target: "_self",
    description: ""
  },
  {
    name: "Call Detail Report",
    type: "Management",
    url: "/app/reports/call-detail",
    target: "_self",
    description: ""
  },
  {
    name: "Customer Annual Revenue Analysis",
    type: "Management",
    url: "/app/reports/customer-annuel-revenue-analytics",
    target: "_self",
    description: ""
  },
  // {
  //   name: "Customer Collection",
  //   type: "Management",
  //   url: "/app/reports/customer-collection",
  //   target: "_self",
  //   description: "",
  //   hide: true
  // },
  {
    name: "Customer Project Status",
    type: "Management",
    url: "/app/reports/customer-project-status",
    target: "_self",
    description: ""
  },
  {
    name: "Daily Call Completion",
    type: "Management",
    url: "/app/reports/daily-call-completion",
    target: "_self",
    description: ""
  },
  {
    name: "Employee Summary By Department",
    type: "Management",
    url: "/app/reports/employee-summary",
    target: "_self",
    description: ""
  },
  {
    name: "Employee Summary By Project",
    type: "Management",
    url: "/app/reports/employee-summary-by-project",
    target: "_self",
    description: ""
  },
  {
    name: "Employee Utilization",
    type: "Management",
    url: "/app/reports/employee-utilization",
    target: "_self",
    description: ""
  },
  // {
  //   name: "Invoice Detail",
  //   type: "Management",
  //   url: "/app/reports/invoice-detail",
  //   target: "_self",
  //   description: "A breakdown of calls formatted to be imported for invoicing"
  // },
  {
    name: "IT Managed Services",
    type: "Customer",
    url: "/app/reports/it-managed-services",
    target: "_self",
    description:
      "A monthly breakdown for Managed Services contracts with a PDF export for customers",
    new: true
  },
  {
    name: "Monthly Revenue Analysis",
    type: "Management",
    url: "/app/reports/monthly-revenue-analysis",
    target: "_self",
    description: ""
  },
  {
    name: "Open Support Tickets",
    type: "Management",
    url: "/app/reports/open-support-tickets",
    target: "_self",
    description: ""
  },
  {
    name: "Practice Summary",
    type: "Management",
    url: "/app/reports/department-project-summary",
    target: "_self",
    description:
      "A weekly breakdown of projects and resources by department with a PDF export",
    new: true
  },
  {
    name: "Prepaid Customer Balance Summary",
    type: "Management",
    url: "/app/reports/customer-balance-summary",
    target: "_self",
    description: ""
  },
  {
    name: "Prepaid Deferred Revenue Balance",
    type: "Management",
    url: "/app/reports/prepaid-deferred-revenue-balance",
    target: "_self",
    description: ""
  },
  {
    name: "Project Progress",
    type: "Management",
    url: "/app/reports/project-progress",
    target: "_self",
    description: ""
  },
  {
    name: "Project Service Analysis",
    type: "Management",
    url: "/app/reports/project-service-analysis",
    target: "_self",
    description: ""
  },
  {
    name: "Project Summary By Customer",
    type: "Management",
    url: "/app/reports/project-summary-by-customer",
    description: ""
  },
  {
    name: "Project Summary By Project Manager",
    type: "Management",
    url: "/app/reports/project-summary",
    target: "_self",
    description: ""
  },
  {
    name: "PTO Balance",
    type: "Management",
    url: "/app/reports/pto-balance-report",
    target: "_self",
    description: ""
  },
  {
    name: "Retainer/Client Care Contracts to Expire",
    type: "Management",
    url: "/app/reports/retainer-or-client-care-contracts",
    target: "_self",
    description: ""
  },
  {
    name: "Sales Performace",
    type: "Management",
    url: "/app/reports/sales-performance",
    target: "_self",
    description: ""
  },
  {
    name: "Support Ticket Detail",
    type: "Management",
    url: "/app/reports/support-ticket-detail",
    target: "_self",
    description: ""
  },
  {
    name: "Task Detail Report",
    type: "Management",
    url: "/app/reports/task-detail",
    target: "_self",
    description: ""
  },
  {
    name: "Time Summary",
    type: "Customer",
    url: "/app/reports/time-summary",
    target: "_self",
    description: ""
  },
  {
    name: "Time Tracker",
    type: "Customer",
    url: "/app/reports/time-tracker",
    target: "_self",
    description: ""
  }
].map((report, index) => ({ ...report, id: index + 1 }));

const ReportsPage = (props) => {
  const history = useHistory();

  const onRowClick = (item) => {
    const { url } = item;
    if (url.includes("https") || url.includes("http")) {
      window.open(url, "_blank");
    } else {
      history.push(item.url);
    }
  };

  return (
    <React.Fragment>
      <HeaderWrapper breadcrumbs={[{ label: "Reports" }]} />
      <div className="content-wrapper transparent">
        <ReportsList
          auth={props.auth}
          reports={reports.filter((item) => item.new)}
        />
      </div>
      <div className="content-wrapper">
        <ReactTable
          defaultPageSize={reports.length}
          className="-highlight"
          data={reports}
          columns={[
            {
              id: "icon",
              Header: "",
              accessor: "_id",
              disableSortBy: true,
              sortable: false,
              maxWidth: 50,
              Cell(cell) {
                return cell?.original?.type === "Customer" ? (
                  <React.Fragment>
                    <a
                      id={cell?.original?.id}
                      data-tooltip-content="Customer Friendly Report"
                      data-tooltip-variant={
                        props.auth.isNightMode ? "dark" : "light"
                      }
                    >
                      <IoBusiness className="icon" />
                    </a>
                    <ReactTooltip
                      anchorId={cell?.original?.id}
                      className={`custom-tooltip ${
                        props.auth.isNightMode ? "dark" : "light"
                      }`}
                      place="right"
                    />
                  </React.Fragment>
                ) : (
                  <div />
                );
              }
            },
            {
              id: "name",
              Header: "Report Name",
              accessor: "name",
              disableSortBy: true,
              sortable: false,
              maxWidth: 300
            },
            {
              id: "description",
              Header: "Description",
              accessor: "description",
              disableSortBy: true,
              sortable: false
            },
            {
              id: "type",
              Header: "Type",
              accessor: "type",
              disableSortBy: true,
              sortable: false,
              maxWidth: 200
            }
          ]}
          showPagination={false}
          getTrProps={(state, { original }) => ({
            onClick: () => {
              onRowClick(original);
            }
          })}
        />
      </div>
    </React.Fragment>
  );
};

ReportsPage.propTypes = {
  auth: PropTypes.object
};
export default ReportsPage;
